<ng-container *ngIf="(base64$()) else loading">
    <div class="warp-image">
        <img class="image" [src]="base64$()" alt="Image">
    </div>
    <div class="remove pointer" (click)="remove()" translate>
        <svg-icon svgClass="svg-img" src="/assets/images/definitions/remove.svg"></svg-icon>
        definitions.logo.remove
    </div>
</ng-container>
<ng-template #loading>
<ng-container *ngIf="question$()?.statusImage==enumImageStatus.Load  else dragOrUpload">
    <div class="load-warp">
        <div class="load-item"></div>
    </div>
    </ng-container>
</ng-template>
<ng-template #dragOrUpload>
    <div class="warp-image">
        <label class="title">
            <input multiple type="file" (change)="onFileSelected($event)" *ngIf="!isDisplay" accept="image/*" />
            <img src="/assets/images/question-menu/add-image.svg">
            <p translate>questionBoard.edit.add-image</p>
        </label>
    </div>
</ng-template> 
<!-- <div queDrag (FilesEvent)="filesDroped($event)" class="warp-image">
        <div class="title">
            <img src="/assets/images/question-menu/add-image.svg">
            <p translate>questionBoard.edit.add-image</p>
        </div>
        <label class="upload" translate>
            <input multiple type="file" [formControl]="file" (change)="onFileSelected($event)" />
            <img src="/assets/images/definitions/upload.svg">
            definitions.logo.upload
        </label>
        <p class="dragP" translate>definitions.logo.drag</p>

    </div> -->